module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-steps"
  }, _vm._l((_vm.stepOptions), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "rt-step",
      class: {
        isfinished: index <= _vm.currentIndex
      }
    }, [(index < _vm.currentIndex) ? _c('rt-icon', {
      attrs: {
        "size": "14",
        "color": "#1890FF",
        "name": "rt-base-check-circle"
      }
    }) : (index == _vm.currentIndex) ? _c('rt-icon', {
      attrs: {
        "size": "14",
        "color": "#1890FF",
        "name": "rt-base-current"
      }
    }) : _c('rt-icon', {
      attrs: {
        "size": "14",
        "color": "#A9C2E8",
        "name": "rt-base-circle-line"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "step-content"
    }, [_vm._v(_vm._s(item.Text))])], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f65e92a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/steps/main.vue
// module id = 1496
// module chunks = 124